import AmplifyWrapper from '../service/auth.service';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';

const requestLogout = () => {
	return {
		type: LOGOUT
	};
};

const recieveLogoutSuccess = data => {
	return {
		type: LOGOUT_SUCCESS,
		data
	};
};

const recieveLogoutError = error => {
	return {
		type: LOGOUT_ERROR,
		error
	};
};

export const logout = () => {
	return async function(dispatch) {
		//
		dispatch(requestLogout());

		AmplifyWrapper.signOut()
			.then(data => {
				dispatch(recieveLogoutSuccess(data));
			})
			.catch(err => {
				dispatch(recieveLogoutError(err));
			});
	};
};
